import type { NavigationLink } from "@components/header/types";
import Link from "@components/Link";
import { useMarket } from "@context/marketContext";

import { useMenuStore } from "@/stores/menuStore";

type MobileMenuTitleProps = {
  link?: NavigationLink;
  showAllTitle: string;
};

const MobileMenuTitle = ({ link, showAllTitle }: MobileMenuTitleProps) => {
  const { locale } = useMarket().state.market;
  const setMobileMenuOpen = useMenuStore((state) => state.setMobileMenuOpen);

  return (
    <div className="border-gray-150 flex w-full items-center justify-between border-b px-4 py-4">
      <span className="all-small-caps text-base font-normal tracking-wider uppercase">
        {link?.title}
      </span>
      <Link
        className="all-small-caps tracking-wider uppercase"
        locale={locale}
        href={link?.slug}
        onClick={() => setMobileMenuOpen(false)}
      >
        {showAllTitle}
      </Link>
    </div>
  );
};

MobileMenuTitle.displayName = "MobileMenuTitle";

export default MobileMenuTitle;
